export const heroImage =
  'https://cdn.magicpatterns.com/uploads/wdhp6JKMYRTbG55MFoAWbM/Imagen_de_ChatGPT_28_sept_2026,_20_34_20-Photoroom.webp'

/** Link di pagamento: sostituiscilo con il link reale del checkout. */
export const checkoutUrl = 'https://yoga-kit-pro.impultienda.ar/checkout'
export const brandName = 'Yoga Kit Pro™'
export const price = '€19'
export const fullPrice = '€387'
export const futurePrice = '€97'
export const discount = '-95%'
export const bonusValue = '€118'
/** Valore dei 6 volumi: fullPrice (€387) − bonusValue (€118). */
export const volumesValue = '€269'
export const launchSpots = 100

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '70+', label: 'Lezioni pronte' },
  { value: '6', label: 'Volumi' },
  { value: '5', label: 'Bonus strategici' },
]

export const heroBadges: string[] = [
  '100% in italiano',
  'Accesso immediato',
  'Formato PDF',
  'Garanzia 7 giorni',
]

/** I problemi che l'insegnante riconosce. */
export const pains: string[] = [
  'Notti perse a cercare sequenze che funzionino davvero',
  'Classi che si ripetono perché ricadi sempre sugli stessi schemi',
  'Entri in sala con la sensazione di non essere del tutto preparata',
  'I tuoi studenti sentono quando improvvisi, anche se tu pensi di nasconderlo',
  'I weekend spariscono nella pianificazione invece di essere per te',
  'La fatica mentale di creare tutto da zero ogni volta',
]

/** Cosa ricevi con Yoga Kit Pro™. */
export const included: string[] = [
  '6 volumi in PDF',
  '70+ lezioni pronte',
  'Script e varianti',
  '5 bonus strategici',
  'Accesso per sempre',
  'Nessun abbonamento',
]

/** La chiusura: cosa lasci alle spalle e cosa ottieni. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Passare altre domeniche sera a cercare sequenze', positive: false },
  { text: 'Improvvisare in classe', positive: false },
  {
    text: 'Perdere fiducia quando un allievo chiede una variante',
    positive: false,
  },
  { text: 'Entra in sala completamente preparata', positive: true },
  { text: 'Insegna con autorità e fluidità', positive: true },
  { text: 'I tuoi studenti sentono la differenza', positive: true },
  { text: 'Recupera i tuoi weekend', positive: true },
  {
    text: 'Costruisci una pratica di insegnamento sostenibile',
    positive: true,
  },
]
